import { StoreName } from '../entities/StoreName';
import { environment } from 'src/environments/environment';
import { FORM_CONTROL_MODES, FORM_CONTROL_TYPES, VALIDATOR_ACTIONS } from '../enums/general.enum';

export class GlobalConstants {
  public static ACCESS_TOKEN = 'ACCESS_TOKEN';
  public static IS_AUTHENTICATED = 'IS_AUTHENTICATED';
  public static IS_PRIVACYACCEPTED = 'IS_PRIVACYACCEPTED';
  public static IS_TERMSACCEPTED = 'IS_TERMSACCEPTED';
  public static dbName = 'RecoveryTracDB';
  public static CONNECTION_KEY = 'Connection';
  public static USER_KEY = 'currentUser';
  public static LOGGING_SETTINGS_KEY = 'loggingSettings';
  public static REMEMBER_EMAIL = 'rememberEmail';
  public static FIREBASE_TOKEN = 'firebaseToken';
  public static LAST_DATABASE_UPLOAD_DATE = 'lastDatabaseUploadDate';
  public static SUPPRESS_INVALID_SYNC_ALERT_DATE = 'suppressInvalidSyncAlertDate';
  public static SUPPRESS_ALREADY_VERIFIED_ALERT_DATE = 'suppressAlreadyVerifiedAlertDate';
  public static SUPPRESS_MILEAGE_LOG_ALERT_DATE = 'suppressMileageLogAlertDate';
  public static ODOMETER_PHOTO_REMINDER_HEADER = 'Odometer Photo Reminder';
  public static ODOMETER_PHOTO_REMINDER_MESSAGE = 'A photo of your odometer may be required for you to be reimbursed for mileage. Please add a photo at the first opportunity by going to the Activity Log page and tapping the Total Mileage card.';
  public static CREDENTIAL_CHECKER = 'credentialChecker';
  public static TEAM_RECORDS_SYNCMASTER_KEY = 'teamRecords';
  public static QR_CODE_AUTO_GENERATE_KEY = 'qrCodeGenerateWithoutPrompt';
  public static QR_CODE_MAX_CHARACTERS = 4200;
  public static PRODUCER_FORM_DOCUMENT_NUMBER_CONTROL_KEY = 'producer_form_document_number';
  public static INPUT_TYPE_PATTERN = (platform: string, version: string) => `Flex_${platform}_${version}`;
  public static LOCATION_STORAGE_KEY = 'geolocation';
  public static PUSH_REGISTRATION_URI = environment.notificationApiUrl + '/push-registrations';
  public static TASK_READ_URI = '/Project/{}/Task'; //replace {} with project id whereever this url is called
  public static PHOTO_UPLOAD_URI = '/attachment/GetFileUploadToken';
  public static LOG_USER_POSITION_URI = '/Mobile/LogUserPosition';
  public static GET_TEAM_RECORDS_URI = '/Mobile/GetTeamRecords';
  public static GET_SYSTEM_INFO_URI = '/Mobile/SystemInfo';
  public static DELETE_ATTACHMENT_URI = '/Attachment/';
  public static USER_READ_URI = '/User/{}'; //replace {} with user id whereever this url is called
  public static BADGE_PHOTO_URI = environment.userApiUrl + '/User/badge-photo';
  public static ORGANIZATION_LOGO_URI = environment.userApiUrl + '/User/organization-logo';
  public static FORM_DOCUMENTS_UPLOAD_URI = environment.flexFormsApiUrl + '/documents';
  public static DEVICE_IDS_URI = environment.flexFormsApiUrl + '/device-ids';
  public static FORM_DEFINITIONS_SYNC_URI = environment.flexFormsApiUrl + '/form-definitions/sync';
  public static CHOICE_DEFINITION_SYNC_URI = environment.flexFormsApiUrl + '/choice-definitions/sync';
  public static DEFAULT_VIDEO_MAX_DURATION_IN_SECONDS = 120;
  public static DEFAULT_VIDEO_MAX_SIZE_IN_MB = 100;

  public static ARRAY_CONTROLS: string[] = [FORM_CONTROL_TYPES.CHECKBOX, FORM_CONTROL_TYPES.CHOICE, FORM_CONTROL_TYPES.GROUP, FORM_CONTROL_MODES.IMAGE, FORM_CONTROL_TYPES.DIAGRAM];
  public static MEDIA_CONTROLS: string[] = [FORM_CONTROL_TYPES.FILE, FORM_CONTROL_TYPES.DIAGRAM, FORM_CONTROL_TYPES.SIGNATURE];

  public static uploadEntity: any = [
    { tableName: StoreName.Photo, url: 'photo' },
    {
      tableName: StoreName.Attachment,
      url: environment.attachmentApiUrl + '/Attachment',
      updateUrl: environment.attachmentApiUrl + '/Attachment',
    },
  ];

  public static STORE_URLS = {
    IOS: 'https://apps.apple.com/us/app/recoverytrac-flex/id6504584614',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.tetratech.recoverytracflex&hl=en_US',
  };

  public static SUPPORT_EMAIL = 'support@recoverytrac.zendesk.com';

  public static LOGINFAILED_NETWORK = 'Unable to reach server. Please ensure you have an Internet connection and try again.';

  public static LOGINFAILED_GENERAL = 'Login failed';

  public static DEFAULT_TIMECLOCK_INTERVAL_MINUTES = 15;
  public static RAW_TIMECLOCK_INTERVAL_MINUTES = 1;
  public static TIME_BETWEEN_EXPORTS_MIN = 5;

  public static MAX_BLOB_STORAGE_REQUEST_TIMEOUT_SECONDS = 10800;
  public static MAX_BLOB_STORAGE_CHUNK_SIZE = 4 * 1024 * 1024; // 4MB

  public static GPS_MAX_WAIT_TIME = 50000;
  public static GPS_TRACKING_DISTANCE_THRESHOLD = 32.8084; // 10 meters in feet
  public static GPS_TRACKING_MAX_TIMEOUT = 30000; // 30 seconds
  public static BACKGROUND_LOCATION_FETCH_TIMEOUT = 15000; // 15 seconds
  public static BACKGROUND_LOCATION_FETCH_INTERVAL = 500; // 0.5 seconds
  public static LAST_KNOWN_LOCATION_MAX_AGE = 180000; // 3 minutes
  public static GPS_TRACKING_POLLING_INTERVAL = 180000; // 3 minutes

  public static STANDARD_OUTFIELDS = ['LayerType', 'LayerName'];

  public static DOCUMENT_ID_SEQUENCE_START_BASE36 = 46656;
  public static COORDINATES_PRECISION = 7;
  public static TIME_ROUND_TO_MINUTES = 15;
  public static CALL_DUE_TIME_MS = 90000;
  public static ONE_MINUTE_MS = 60000;
  public static BREAK_SYNC_LOCK_AFTER_MIN = 3;
  public static START_OF_WEEK = 6; //Saturday
  public static DEFAULT_CANVAS_WIDTH = 1080;
  public static DEFAULT_CANVAS_HEIGHT = 720;
  public static DEFAULT_IMAGE_LIST_LIMIT = 12;
  public static METER_TO_FOOT_CONVERSION_RATE = 3.280839895;
  public static FOOT_TO_METER_CONVERSION_RATE = 0.3048;
  public static SEARCH_LIST_ITEM_DISPLAY_LIMIT = 10;
  public static DEFAULT_QUALITY = 10;
  public static DEFAULT_BADGE_PHOTO_DIMENSIONS = { width: 400, height: 640 };
  public static DEFAULT_BADGE_PHOTO_SIZE_LIMIT_IN_MB = 3;
  public static SEARCH_LIST_ITEM_LIMIT = 500;
  public static CHOICE_LIST_ITEM_LIMIT = 30;
  public static DELETE_DOCUMENTS_DATE_THRESHOLD_DAYS = 14;
  public static IN_PROGRESS_DOCUMENTS_TIME_THRESHOLD_MS = 3600000;
  public static SYNC_MODIFIED_DATE_BUFFER_MINUTES = 1;
  public static AUTOCOMPLETE_CONTROL_TYPES = [
    FORM_CONTROL_TYPES.TEXT,
    FORM_CONTROL_TYPES.NUMBER,
    FORM_CONTROL_TYPES.TEXTAREA,
    FORM_CONTROL_TYPES.CHECKBOX,
    FORM_CONTROL_TYPES.RADIO,
    FORM_CONTROL_TYPES.CHOICE,
  ];
  public static VISUAL_CONTROL_TYPES = [FORM_CONTROL_TYPES.DIVIDER, FORM_CONTROL_TYPES.HEADER, FORM_CONTROL_TYPES.QR_CODE_SCANNER, FORM_CONTROL_TYPES.CHOICE_IMAGE];

  // FORM BUILDER CONSTANTS
  public static SYNC_DUPLICATE_ID_ERROR = 'DocumentId already exists.';
  public static ESRI_LOCATOR_URL = 'https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer';
  public static KEY_NAMES = {
    RecordId: 'RecordId',
    Id: 'Id',
    Status: 'Status',
    TimeRecordId: 'TimeRecordId',
    TimeRecordRecordId: 'TimeRecordRecordId',
    ActivityLogId: 'ActivityLogId',
    ActivityLogRecordId: 'ActivityLogRecordId',
    ProjectId: 'ProjectId',
    TeamId: 'TeamId',
    UserId: 'UserId',
    FieldActivityId: 'FieldActivityId',
    LaborCategoryId: 'LaborCategoryId',
    UserId_Date: 'UserId_Date',
    UserId_ProjectId_Date: 'UserId_ProjectId_Date',
    SyncType_Id: 'SyncType_Id',
    DocumentId: 'DocumentId',
    SyncStatus: 'SyncStatus',
    ModifiedDate: 'ModifiedDate',
    FormDefinitionBaseId: 'FormDefinitionBaseId',
    SyncStatus_ModifiedDate: 'SyncStatus_ModifiedDate',
    OdomterReadingRecordId: 'OdomterReadingRecordId',
  };
  public static DEFAULT_PRIMARY_KEY = GlobalConstants.KEY_NAMES.RecordId;

  public static KIOSK_COUNT_DOWN = 5;
  public static FORM_LEVEL_ACTIONS = [VALIDATOR_ACTIONS.SUBMIT_FORM, VALIDATOR_ACTIONS.REJECT_FORM];

  public static readonly DEFAULT_BROKEN_IMAGE_PATH = 'assets/images/broken_image.png';
}
